import { TAlarmConfig, TDeviceConfig } from "../../models/TDeviceConfig";

export type TAlarm = {
	pattern: string;
	displayName: string;
};

export class AlarmsConfig {
	private readonly alarmsConfig: TDeviceConfig;

	public constructor(data?: TAlarm[] | null) {
		const config: TDeviceConfig = { alarms: [] };
		data?.forEach((alarm: TAlarm) => {
			const el: TAlarmConfig = {
				pattern: new RegExp(alarm.pattern,"i"),
				displayName: alarm.displayName,
			};
			config.alarms.push(el);
		});
		this.alarmsConfig = config;
	}

	public getAlarmsConfig(): TDeviceConfig {
		return this.alarmsConfig;
	}
}
